import { AXIOS } from "@/AXIOS/http-common";

const state = {
  listAllHistory: [],
};

const urlPrefix = "waste-history";

const actions = {
  async getListAllHistory(context, data) {
    return await AXIOS.get(
      urlPrefix + "/list?page=" + data.page + "&size=" + data.size
    ).then(async (response) => {
      let arr;
      await AXIOS.get("data-entry/get/blockForUserAll").then((response) => {arr = response.data});
      response.data.content.forEach((wh) => {
        const parts = wh.date.split(".");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // JavaScript: месяц с 0
        const year = parseInt(parts[2], 10);
        const dateFromStr = new Date(year, month, day);
        wh.block = false;
        arr.forEach((el) => {
          const dateFromTimestamp = new Date(el);
          const sameYear = dateFromStr.getFullYear() === dateFromTimestamp.getFullYear();
          const sameMonth = dateFromStr.getMonth() === dateFromTimestamp.getMonth();
        
          if (sameYear && sameMonth) 
            wh.block = true;
        });
      }); 
        console.log("response.data",response.data);
        context.commit("setListAllHistory", response.data);
    });
  },

  async searchHistory(context, data) {
    return await AXIOS.post(
      urlPrefix + "/search?page=" + data.page + "&size=" + data.size,
      data.body
    ).then(async (response) => {
      let arr;
      await AXIOS.get("data-entry/get/blockForUserAll").then((response) => {arr = response.data});
      response.data.content.forEach((wh) => {
        const parts = wh.date.split(".");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // JavaScript: месяц с 0
        const year = parseInt(parts[2], 10);
        const dateFromStr = new Date(year, month, day);
        wh.block = false;
        arr.forEach((el) => {
          const dateFromTimestamp = new Date(el);
          const sameYear = dateFromStr.getFullYear() === dateFromTimestamp.getFullYear();
          const sameMonth = dateFromStr.getMonth() === dateFromTimestamp.getMonth();
          console.log("dateFromStr.getFullYear:"+dateFromStr.getFullYear()+" dateFromStr.getMonth():"+dateFromStr.getMonth()+
          " dateFromTimestamp.getFullYear():"+dateFromTimestamp.getFullYear()+" dateFromTimestamp.getMonth():"+dateFromTimestamp.getMonth()+" sameYear:"+sameYear+" sameMonth:"+sameMonth)
          if (sameYear && sameMonth) 
            wh.block = true;
        });
      }); 
        console.log("response.data",response.data);
        context.commit("setListAllHistory", response.data);
    });
  },

  async deleteWasteHistory(context, data) {
    return await AXIOS.post(urlPrefix + "/delete", data);
  },

  async createWHFromTransfer(context, data) {
    return await AXIOS.post(urlPrefix + "/create_wh_from_transfer", data);
  },

  async cancelTransferWasteHistory(context, data) {
    return await AXIOS.post(urlPrefix + "/cancelTransfer", data);
  },

  async deleteTransfer(context, data) {
    return await AXIOS.post(urlPrefix + "/deleteTransfer", data);
  },

  async updateWasteHistory(context, data) {
    return await AXIOS.post(urlPrefix + "/update", data);
  },

  async updateTransfer(context, data) {
    return await AXIOS.post(urlPrefix + "/update_transfer", data);
  },

  async updateTransferPartial(context, data) {
    return await AXIOS.post(urlPrefix + "/update_transfer_partial", data);
  },
};

const mutations = {
  setListAllHistory(state, data) {
    state.listAllHistory = data;
  },
};

const getters = {
  GETLISTALLHISTORY: (state) => state.listAllHistory,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
